import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useCompanyStoreSettings } from "~/hooks/useCompanyStoreSettings";
import type { CompanyStoreSetting } from "~/models/CompanyStoreSetting";
import type { DealSearchCondition } from "~/models/Deal";

export const CompanyStoreCombobox: React.FC = () => {
	const { data: companyStoreSettings } = useCompanyStoreSettings().index();
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const watchedAuthId = useWatch({ control, name: "authId" });

	const selectedCompanyStoreSettingOption = useMemo((): ComponentProps<
		typeof SingleComboBox
	>["value"] => {
		const setting = companyStoreSettings?.find(
			({ authId }) => authId === watchedAuthId
		);
		return setting
			? {
					label: setting.name,
					value: String(setting.authId)
				}
			: null;
	}, [companyStoreSettings, watchedAuthId]);

	const onCompanyStoreSettingChange = useCallback(
		async (
			option: ComponentProps<typeof SingleComboBox>["value"]
		): Promise<void> => {
			setValue("authId", option ? Number(option.value) : undefined);
		},
		[setValue]
	);
	if (companyStoreSettings === null) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onCompanyStoreSettingChange}
			options={companyStoreSettings.map((c: CompanyStoreSetting) => ({
				label: c.name,
				value: String(c.authId)
			}))}
			placeholder="店舗"
			value={selectedCompanyStoreSettingOption}
		/>
	);
};
